import './appNavbarBrand.scss';

import * as React from 'react';

/**
 * Navbar brand image for the app. 
 */
export const AppNavbarBrand = () => {
    return (
        <div className="navbar-brand">
            {/*<div className="navbar-brand-full">
            </div>
            <div className="navbar-brand-minimized">
            </div>*/}
        </div>
        );
};